exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Input {\r\n\ttransition: .3s opacity;\r\n\t-moz-transition: .3s opacity;\r\n\t-webkit-transition: .3s opacity;\r\n\t-ms-transition: .3s opacity;\r\n\tposition: relative;\r\n\tborder: 0px;\r\n\toutline: 0;\r\n\tpadding: 5px 5px;\r\n\tborder-bottom: 1px solid #DDD;\r\n\tfont-family: Roboto;\r\n\tfont-weight: 300;\r\n\tfont-size: 14px;\r\n\tcolor: #444;\r\n}\r\n\r\n.Input:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: graytext;\r\n}\r\n\r\n.Input:invalid {\r\n\tborder-bottom: 1px solid #FF4444;\r\n}\r\n\r\n.Input[type=number]::-webkit-inner-spin-button,\r\n.Input[type=number]::-webkit-outer-spin-button {\r\n\t-webkit-appearance: none;\r\n\tmargin: 0;\r\n}\r\n\r\n.Input.Shadowed {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\tborder-bottom: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Input/Input.css
// module id = 690
// module chunks = 0